import React, { useId } from "react";
import styles from "./RegisterOrderForm.module.css";

type FormSectionProps = {
	/** Left out for the main block of required fields: its labels say what it holds. */
	title?: string;
	children: React.ReactNode;
};

/** One card of the register form: an optional short title and its fields. */
const FormSection = ({ title, children }: FormSectionProps) => {
	const titleId = useId();

	return (
		<section
			className={styles.section}
			aria-labelledby={title ? titleId : undefined}
		>
			{title && (
				<h2 id={titleId} className={styles.sectionTitle}>
					{title}
				</h2>
			)}
			{children}
		</section>
	);
};

export default FormSection;
